import { createContext, useContext } from 'react';

type ProgramsContextValue = {
	fetchData: () => void;
};

export const ProgramsContext = createContext<ProgramsContextValue | null>(null);

export const useProgramsContext = (): ProgramsContextValue => {
	const ctx = useContext(ProgramsContext);

	if (!ctx) {
		throw new Error('useProgramsContext must be used within ProgramsContext.Provider');
	}

	return ctx;
};
